/* eslint-disable camelcase */
import { replaceSpacesWithUnderscoresWithDefault } from '@y2/analytics-common-events/analytics.utils';
import { analytics } from '@y2/google-tag-manager/v2/synchronized';

export const pushClickOpenContactPopupEvent = (
  label: string,
  ProjectID: string,
) => {
  analytics.pushEvent({
    EventName: 'lead_click',
    EventDetail: 'map',
    EventText: replaceSpacesWithUnderscoresWithDefault(label),
    EventGroup: 'contact',
    ProjectID,
    LeadType: 'yad1_blue',
  });
};

export const pushShowLeadPopupEvent = (ProjectID: string) => {
  analytics.pushEvent({
    EventName: 'lead_form_presented',
    EventDetail: 'map',
    EventText: 'null',
    EventGroup: 'contact',
    ProjectID,
    LeadType: 'yad1_blue',
  });
};

export const pushSentLeadInfoEvent = (
  ProjectID: string,
  tracking_id: string,
) => {
  analytics.pushEvent({
    EventName: 'lead',
    EventDetail: 'map_lead',
    EventText: 'mailing_approved',
    EventGroup: 'contact',
    ProjectID,
    tracking_id,
    LeadType: 'yad1_blue',
  });
};

export const pushContactUsFormSubmitEvent = () => {
  analytics.pushEvent({
    EventName: 'publisher_form',
    EventDetail: 'null',
    EventText: 'null',
    EventGroup: 'yad1_interactions',
  });
};
